var _path, _polygon, _rect, _polygon2, _rect2, _polygon3, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCilIndustry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, currentColor)",
    d: "M459.26,96,328,225.7V96H293.475L168,223.267V16H16V496H496V96ZM464,464H48V48h88V264h36.778L296,139.018V264h38.764L464,136.3Z",
    className: "ci-primary"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "136 328 136 336 168 336 168 328 168 304 136 304 136 328",
    className: "ci-primary"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 136,
    y: 376,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "216 328 216 336 248 336 248 328 248 304 216 304 216 328",
    className: "ci-primary"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 216,
    y: 376,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "296 328 296 336 328 336 328 328 328 304 296 304 296 328",
    className: "ci-primary"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 296,
    y: 376,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 376,
    y: 304,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 376,
    y: 376,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilIndustry);
export default __webpack_public_path__ + "static/media/cil-industry.7baf480d2a9c3dccecf76c15afa25195.svg";
export { ForwardRef as ReactComponent };